import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, Link as RouterLink } from "react-router-dom";
import {
    Box,
    Stack,
    Typography,
    Link,
    useTheme,
    CircularProgress
} from "@mui/material";
import NavBar from "../components/Navbar";
import {
    SignIn,
    SignUp,
    useUser
} from "@clerk/clerk-react";

const AuthInner: React.FC<{ isLoginProp?: boolean }> = ({ isLoginProp }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const [isLogin, setIsLogin] = useState<boolean>(isLoginProp ?? true);

    const { isLoaded, isSignedIn } = useUser();

    // ÚJ: csak egyszer navigáljon vissza (különben a user-objektum változásakor többször lépne -1-et)
    const hasRedirected = useRef(false);

    useEffect(() => {
        if (isLoginProp !== undefined) {
            setIsLogin(isLoginProp);
        }
    }, [isLoginProp]);

    useEffect(() => {
        if (isLoaded && isSignedIn && !hasRedirected.current) {
            hasRedirected.current = true;

            //console.log("Sikeres bejelentkezés");

            // ÚJ: vissza az előző oldalra (-1).
            // Ha nincs előző oldal az appon belül (pl. közvetlenül /authpages-et nyitották meg), akkor főoldal.
            if (location.key !== "default") {
                navigate(-1);
            } else {
                navigate("/", { replace: true });
            }
        }
        // direkt csak ezek a függőségek: a user objektum változása ne triggerelje újra
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoaded, isSignedIn]);

    if (!isLoaded) {
        return (
            <Box sx={{ width: "100vw", minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ width: "100vw", minHeight: "100vh", bgcolor: theme.palette.mode === "dark" ? theme.palette.background.default : "#fafafa" }}>
            <NavBar />
            <Box
                sx={{
                    minHeight: "calc(106vh - 64px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    px: 2,
                    py: 4
                }}
            >
                <Stack spacing={2}>
                    {isLogin ? (
                        <Box>
                            <SignIn routing="virtual" />
                        </Box>
                    ) : (
                        <Box>
                            <SignUp routing="virtual" />
                            <Typography variant="caption" align="center" display="block" sx={{ mt: 1.5, maxWidth: 400, mx: "auto" }}>
                                A regisztrációval elfogadod az{" "}
                                <Link component={RouterLink} to="/terms-of-service">ÁSZF-et</Link> és az{" "}
                                <Link component={RouterLink} to="/privacy-policy">Adatvédelmi nyilatkozatot</Link>.
                            </Typography>
                        </Box>
                    )}
                </Stack>
            </Box>
        </Box>
    );
};

const AuthPages: React.FC = () => {
    const location = useLocation();
    const isLoginProp = location.state?.isLogin;

    return (
        <AuthInner isLoginProp={isLoginProp} />
    );
};

export default AuthPages;